const numCaseRegex = new RegExp("^(?=.*[0-9])");
const lowCaseRegex = new RegExp("^(?=.*[a-z])");
const upperCaseRegex = new RegExp("^(?=.*[A-Z])");
const specialCaseRegex = new RegExp("^(?=.*[!@#$%^&*])");

// var expression = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi;
// var urlRegex = new RegExp(expression);

export const passwordValidation = (values) => {


    if (values.trim() === "") {
        return "Required"
    } else if (!numCaseRegex.test(values)) {
        return "Password should contain atleast one number"
    }
    else if (!upperCaseRegex.test(values)) {
        return "Password should contain an Uppercase letter"
    }
    else if (!lowCaseRegex.test(values)) {
        return "Password should contain an Lowcase letter"
    }
    else if (!specialCaseRegex.test(values)) {
        return "Password should contain a special character"
    }

    return "";


};


export const confirmPasswordValidation = (confirmPassword, password) => {
    // let errors;

    // if (confirmPassword.trim() === "") {
    //     return "Required"
    // }
    if (password.trim() === "") {
        return "Please fill in the password field";
    }
    else if (password !== confirmPassword) {
        return "Password does not match";
    }

    return "";
};
export const country = (values) => {
    let errors;
    // console.log("validate", numCaseRegex.test(values));
    // console.log("errors", errors);
    // console.log("values confirmpassword ", values);

    if (values.trim() === "") {
        return "Required";
    }


    return errors;
};



export const emailValidation = (value) => {
  if (!value || value.trim() === "") {
    return "Required";
  }

  const cleaned = value.trim();

  const emailRegex =
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

  if (!emailRegex.test(cleaned)) {
    return `Did you mean ${cleaned.replace(/\s/g, "")}@xyz.com`;
  }

  const domain = cleaned.split("@")[1]?.toLowerCase();

  const allowedDomains = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com"];

  const endsWithNet = domain.endsWith(".net");
  const endsWithNg = domain.endsWith(".ng");
  const endsWithOrg = domain.endsWith(".org");
  const endsWithComNg = domain.endsWith(".com.ng");

  const isAllowed =
    allowedDomains.includes(domain) ||
    endsWithNet ||
    endsWithNg ||
    endsWithOrg ||
    endsWithComNg;

  if (!isAllowed) {
    return "Only Gmail, Yahoo, .net, .ng, .org, .com.ng, Outlook, and Hotmail emails are allowed";
  }

  return null; 
};



export const NameValidation = (field, value) => {
    if (!value || value.trim() === "") {
        return "Required";
    }

    // block invalid characters
    if (!/^[a-zA-Z\s'-]+$/.test(value)) {
        return "Invalid characters";
    }

    // minimum length
    if (value.trim().length < 3) {
        return "Name needs to be at least three characters";
    }

    // maximum length (anti-spam)
    if (value.trim().length > 25) {
        return "Name must not exceed 25 characters";
    }

    return null;
};


export const DeveloperValidation = (values) => {


    if (values.trim() === "") {
        return "Please select an option";
    }

    return null;
};


export const phoneNoValidation = (values) => {


    if (values.trim() === "") {
        return "Required";
    }

    return "";
};

export const BusinessSupport = (values) => {


    if (values.trim() === "") {
        return "Required";
    }

    return "";
};

export const BusinessWebsite = (values) => {


    if (values.trim() === "") {
        return "Required";
         } 
    //      else if (urlRegex.test(
    //     values
    // )) {
    //     return "Please enter a valid website address"
    // }

    return "";
};

export const BusinessName = (values) => {


    if (values.trim() === "") {
        return "Required";
    }
    else if (values.trim().length < 3) {
        return `Business Name should be at least three characters`;
    }



    return "";
};
// export const BusinessSector = (values) => {



//     return "";
// };

export const Terms = (values) => {

    if (!values) {
        return "Required";
    }




    return "";
};

